import { render, staticRenderFns } from "./AdminDialog.vue?vue&type=template&id=787f3932&"
import script from "./AdminDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports